"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const either_1 = require("../../../types/either");
const Printable_1 = require("../../../models/printables/Printable");
const layers_1 = require("../../layers");
const helpers_1 = require("./helpers");
const addCustomEditableTextLayer_1 = __importDefault(require("./addCustomEditableTextLayer"));
const addEditableTextLayerToPrintable = (project, action) => {
  const interiorPrintableGroupIndex = project.printableGroups.findIndex(p => p.type === 'interior');
  if (interiorPrintableGroupIndex === -1) {
    return (0, either_1.left)(new Error(`Interior Printable Group Index not found in project ${project.id}`));
  }
  const currentPrintable = project.printableGroups[interiorPrintableGroupIndex].printables.find(p => p.id === action.printableId);
  // get the current printable to know the number of the editable text layer.
  if (!currentPrintable) {
    return (0, either_1.left)(new Error(`Printable ${action.printableId} not found`));
  }
  // Calculate maxZIndex for the new editable text layer
  const maxZIndex = 1 + (currentPrintable.layers && currentPrintable.layers.length !== 0 ? Math.max(...currentPrintable.layers.map(l => l.zIndex || 1)) : 0);
  // Create a new printable with the new version
  const newPrintable = (0, Printable_1.updatePrintableVersion)(currentPrintable, action.timestamp);
  // Get the number of editable text layers in the current printable.
  const currentNumEditableTextLayers = (0, helpers_1.getNumEditableTextLayersInPrintable)(currentPrintable, action.activePage);
  // To get the design group we need to know if a composite design because if it is printable.designId = desigIdLeft|designIdRight
  let currentDesignId;
  if (currentPrintable.isCompositeDesign) {
    const partialDesigns = currentPrintable.designId.split('|');
    currentDesignId = action.activePage === layers_1.CoverageType.LEFT ? partialDesigns[0] : partialDesigns[1];
  } else {
    currentDesignId = currentPrintable.designId;
  }
  const newEditableTextLayerResult = (0, addCustomEditableTextLayer_1.default)(currentNumEditableTextLayers, currentDesignId, currentPrintable, action.activePage, maxZIndex);
  if (newEditableTextLayerResult.isLeft()) {
    return (0, either_1.left)(newEditableTextLayerResult.value);
  }
  newPrintable.layers.push(newEditableTextLayerResult.value);
  // Put the newly updated printable copy in the appropriate printable group
  const printableIdx = project.printableGroups[interiorPrintableGroupIndex].printables.findIndex(p => p.id === action.printableId);
  project.printableGroups[interiorPrintableGroupIndex].printables[printableIdx] = newPrintable;
  const updatedEntities = [newPrintable];
  updatedEntities.push(project);
  return (0, either_1.right)({
    updatedProject: project,
    updatedEntities
  });
};
exports.default = addEditableTextLayerToPrintable;